import "./i18n";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import i18n from "./i18n";
import { initAnalytics } from "./lib/analytics";
import { setAnalyticsConsent, captureFromUrl } from "./lib/attribution";
import { captureReferralFromUrl } from "./lib/referral-capture";
import { readAnalyticsConsent } from "./lib/consent";
import { preloadPaymobPixel } from "./lib/paymob";
import "./globals.css";

// Best-effort: only initialises when VITE_POSTHOG_KEY is set. No-op otherwise.
initAnalytics();

// Marketing attribution: seed the prior consent decision (if any), then read
// UTM / click-id / campaign params from the landing URL. Capture runs here at
// bootstrap — before React Router strips query params on the first navigation.
setAnalyticsConsent(readAnalyticsConsent());
captureFromUrl(window.location.search);

// Inbound referral: capture the referrer's `?ref=` code on landing (before the
// router strips query params) so it can be attached to the order at checkout.
// Not consent-gated — it's a customer-supplied referral, not tracking metadata.
captureReferralFromUrl();

// Paymob SDK is heavy; fetch it in the background after first render so
// checkout opens instantly without delaying the menu.
window.addEventListener("load", preloadPaymobPixel, { once: true });

// Register the service worker only in production builds.
// Dev keeps SW disabled to avoid cache/HMR interference.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  void navigator.serviceWorker.register("/sw.js").catch(() => {
    /* SW unavailable or registration failed — non-fatal. */
  });
}

i18n.on("languageChanged", (lng) => {
  document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = lng;
});

// Apply current direction on first load too
document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
document.documentElement.lang = i18n.language || "en";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
